import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./Card.module.css";
/**
 * Card do Azim CRM.
 * Superfície plana, sem gradientes.
 * Quando `hover=true`, eleva sutilmente ao passar o mouse.
 * Quando `onClick` é passado, fica focável pelo teclado.
 * Quando `variant="glass"`, usa superfície translúcida com blur (Onda A).
 */
export function Card({ children, pad = true, hover = false, variant = "solid", className, onClick, ...rest }) {
    const isInteractive = !!onClick || hover;
    const cls = [
        styles.card,
        variant === "glass" ? styles.glass : "",
        pad ? styles.padded : "",
        isInteractive ? styles.hoverable : "",
        className ?? "",
    ]
        .filter(Boolean)
        .join(" ");
    if (isInteractive) {
        return (_jsx("div", { role: "button", tabIndex: 0, onClick: onClick, onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick?.(e);
                }
            }, className: cls, ...rest, children: children }));
    }
    return (_jsx("div", { className: cls, ...rest, children: children }));
}
//# sourceMappingURL=Card.js.map